var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _g7, _path37, _path38, _path39, _path40, _path41, _path42, _g8, _g9, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g10, _path55, _path56, _path57, _path58, _path59, _path60, _g11, _path61, _path62, _path63, _path64, _path65, _path66, _g12, _g13, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1288,
    height: 587,
    viewBox: "0 0 1288 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.693 275.296L293.628 327.227L81.0342 203.89L174.352 151.959L383.693 275.296Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.125 278.797L201.469 295.138L268.365 256.324L239.004 239.983L173.125 278.797Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.126 365.094L201.47 381.434L268.366 342.628L239.005 326.287L173.126 365.094Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.291 365.094L201.627 381.434L268.523 342.628L239.162 326.287L173.291 365.094Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.469 295.137V381.432",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.743 239.983V326.286L268.335 342.597V256.294",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.126 278.513V364.808",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.484 240.088L145.828 256.428L212.717 217.622L183.356 201.281L117.484 240.088Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.485 326.39L145.828 342.731L212.717 303.917L183.356 287.576L117.485 326.39Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.649 326.39L145.986 342.731L212.882 303.917L183.521 287.576L117.649 326.39Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.828 256.429V342.732",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.102 201.281V287.577L212.695 303.888V217.592",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.485 239.803V326.106",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6484 203.339L85.9848 219.68L152.881 180.866L123.52 164.525L57.6484 203.339Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6484 289.636L85.9848 305.976L152.881 267.17L123.52 250.829L57.6484 289.636Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8054 289.636L86.1493 305.976L153.045 267.17L123.677 250.829L57.8054 289.636Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9851 219.681V305.976",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.266 164.525V250.828L152.851 267.139V180.844",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6484 203.056V289.351",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 164.629L30.3439 180.969L97.2399 142.163L67.8789 125.822L2 164.629Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 250.932L30.3439 267.273L97.2399 228.467L67.8789 212.126L2 250.932Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16479 250.932L30.5087 267.273L97.3972 228.467L68.0362 212.126L2.16479 250.932Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.344 180.971V267.274",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6248 125.822V212.125L97.2101 228.436V142.133",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 164.344V250.647",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.66 165.279L396.997 181.62L463.893 142.813L434.532 126.473L368.66 165.279Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.659 251.581L396.996 267.922L463.892 229.108L434.531 212.768L368.659 251.581Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.817 251.581L397.16 267.922L464.056 229.108L434.696 212.768L368.817 251.581Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.996 181.62V267.923",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.277 126.473V212.768L463.862 229.079V142.783",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.659 164.994V251.297",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M313.67 133.137L342.014 149.478L408.91 110.672L379.549 94.3311L313.67 133.137Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M313.67 219.441L342.014 235.782L408.91 196.968L379.549 180.627L313.67 219.441Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M313.835 219.441L342.172 235.782L409.068 196.968L379.707 180.627L313.835 219.441Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M342.014 149.479V235.781",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M379.288 94.3311V180.627L408.881 196.937V110.642",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.67 132.853V219.155",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M253.834 96.3862L282.171 112.727L349.067 73.913L319.706 57.5723L253.834 96.3862Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M253.834 182.682L282.171 199.023L349.067 160.217L319.706 143.876L253.834 182.682Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M253.991 182.682L282.335 199.023L349.231 160.217L319.87 143.876L253.991 182.682Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M282.171 112.728V199.023",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M319.452 57.5723V143.875L349.037 160.186V73.8905",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M253.834 96.1025V182.398",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.844 64.8953L227.188 81.236L294.084 42.4296L264.723 26.0889L198.844 64.8953Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.844 151.198L227.188 167.539L294.084 128.732L264.723 112.392L198.844 151.198Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.009 151.198L227.353 167.539L294.241 128.732L264.88 112.392L199.009 151.198Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.188 81.2363V167.539",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.469 26.0889V112.392L294.054 128.703V42.3997",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.844 64.6191V150.915",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M638.474 271.455L610.13 287.795L543.234 248.981L572.595 232.641L638.474 271.455Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M638.474 357.751L610.13 374.091L543.234 335.285L572.595 318.944L638.474 357.751Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M638.31 357.751L609.973 374.091L543.077 335.285L572.438 318.944L638.31 357.751Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M610.131 287.796V374.091",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M572.857 232.641V318.944L543.265 335.254V248.959",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M638.475 271.17V357.465",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.338 478.934L786.273 530.865L573.679 407.528L666.997 355.597L876.338 478.934Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.055 303.345L553.719 319.686L486.823 280.872L516.184 264.531L582.055 303.345Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.055 389.641L553.719 405.982L486.823 367.176L516.184 350.835L582.055 389.641Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.899 389.641L553.555 405.982L486.659 367.176L516.02 350.835L581.899 389.641Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.719 319.686V405.981",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.438 264.531V350.834L486.853 367.145V280.842",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.056 303.062V389.357",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M819.171 314.608L790.827 330.949L723.931 292.135L753.3 275.794L819.171 314.608Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M819.171 400.904L790.827 417.245L723.931 378.438L753.3 362.098L819.171 400.904Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M819.007 400.904L790.67 417.245L723.774 378.438L753.135 362.098L819.007 400.904Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M790.827 330.949V417.245",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M753.554 275.794V362.097L723.961 378.408V292.105",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M819.171 314.324V400.62",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M906.993 363.294L878.649 379.634L811.753 340.828L841.122 324.487L906.993 363.294Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.993 449.596L878.649 465.937L811.753 427.123L841.121 410.782L906.993 449.596Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.829 449.596L878.492 465.937L811.596 427.123L840.957 410.782L906.829 449.596Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.649 379.635V465.938",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.376 324.487V410.783L811.783 427.094V340.798",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.993 363.009V449.312",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M661.516 256.236L689.859 272.577L756.748 233.77L727.387 217.43L661.516 256.236Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M661.516 342.539L689.859 358.879L756.748 320.065L727.387 303.725L661.516 342.539Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M661.673 342.539L690.017 358.879L756.913 320.065L727.552 303.725L661.673 342.539Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M689.86 272.577V358.88",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M727.133 217.43V303.725L756.726 320.036V233.74",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M661.516 255.951V342.254",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.144 217.355L627.488 233.696L694.384 194.882L665.015 178.541L599.144 217.355Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.144 303.651L627.488 319.992L694.384 281.185L665.015 264.845L599.144 303.651Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.309 303.651L627.645 319.992L694.541 281.185L665.18 264.845L599.309 303.651Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.762 178.541V264.844L694.355 281.155V194.859",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.144 303.367V217.071L627.488 233.696V319.992",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.771 482.428L694.114 498.768L761.01 459.962L731.649 443.621L665.771 482.428Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.771 568.73L694.114 585.071L761.01 546.257L731.649 529.916L665.771 568.73Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.935 568.73L694.271 585.071L761.167 546.257L731.807 529.916L665.935 568.73Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.115 498.769V585.072",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.388 443.621V529.917L760.981 546.227V459.932",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.771 482.143V568.446",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M610.13 443.725L638.474 460.066L705.37 421.252L676.001 404.911L610.13 443.725Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M610.13 530.022L638.474 546.363L705.37 507.557L676.001 491.216L610.13 530.022Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M610.294 530.022L638.631 546.363L705.527 507.557L676.166 491.216L610.294 530.022Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M638.474 460.066V546.362",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M675.747 404.911V491.214L705.339 507.525V421.229",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M610.13 443.441V529.737",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1286 227.713L1257.66 244.053L1190.77 205.247L1220.13 188.906L1286 227.713Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1286 314.016L1257.66 330.357L1190.77 291.543L1220.13 275.202L1286 314.016Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.84 314.016L1257.5 330.357L1190.6 291.543L1219.97 275.202L1285.84 314.016Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.66 244.054V330.357",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.38 188.906V275.202L1190.8 291.513V205.217",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1286 227.428V313.731",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.83 262.803L1120.76 314.734L908.167 191.397L1001.48 139.466L1210.83 262.803Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1238.17 261.315L1209.82 277.656L1142.93 238.849L1172.29 222.509L1238.17 261.315Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238 347.618L1209.67 363.958L1142.77 325.144L1172.13 308.804L1238 347.618Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.82 277.656V363.959",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.55 222.509V308.804L1142.96 325.115V238.82",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.17 261.03V347.333",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.66 98.475L1125.32 114.816L1058.42 76.0019L1087.79 59.6611L1153.66 98.475Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.66 184.77L1125.32 201.111L1058.42 162.305L1087.79 145.964L1153.66 184.77Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.5 184.77L1125.16 201.111L1058.26 162.305L1087.62 145.964L1153.5 184.77Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.32 114.816V201.112",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.04 59.6611V145.964L1058.45 162.275V75.9794",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.66 98.1914V184.487",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.48 147.162L1213.14 163.503L1146.24 124.696L1175.6 108.355L1241.48 147.162Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.48 233.464L1213.14 249.805L1146.24 210.991L1175.6 194.65L1241.48 233.464Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.32 233.464L1212.98 249.805L1146.08 210.991L1175.44 194.65L1241.32 233.464Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.14 163.503V249.806",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.86 108.355V194.651L1146.27 210.969V124.666",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.48 146.877V233.18",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M996.003 40.1043L1024.34 56.445L1091.24 17.6386L1061.87 1.29785L996.003 40.1043Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M996.003 126.407L1024.34 142.747L1091.24 103.934L1061.87 87.5928L996.003 126.407Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M996.16 126.407L1024.5 142.747L1091.4 103.934L1062.04 87.5928L996.16 126.407Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.34 56.4453V142.748",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.62 1.29785V87.5933L1091.21 103.912V17.6087",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M996.003 39.8193V126.122",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M888.176 193.341L916.513 209.682L983.409 170.868L954.048 154.527L888.176 193.341Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.176 279.637L916.513 295.978L983.409 257.172L954.048 240.831L888.176 279.637Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.333 279.637L916.677 295.978L983.573 257.172L954.212 240.831L888.333 279.637Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.794 154.527V240.83L983.387 257.141V170.846",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.176 279.353V193.058L916.513 209.683V295.978",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000.26 266.294L1028.6 282.634L1095.5 243.828L1066.13 227.487L1000.26 266.294Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.26 352.596L1028.6 368.937L1095.5 330.123L1066.13 313.782L1000.26 352.596Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.42 352.596L1028.76 368.937L1095.65 330.123L1066.29 313.782L1000.42 352.596Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.6 282.635V368.938",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.88 227.487V313.783L1095.47 330.101V243.798",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.26 266.009V352.312",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M944.617 227.594L972.961 243.934L1039.85 205.128L1010.49 188.787L944.617 227.594Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M944.617 313.888L972.961 330.229L1039.85 291.423L1010.49 275.082L944.617 313.888Z",
    stroke: "#231F20",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M944.782 313.888L973.118 330.229L1040.01 291.423L1010.65 275.082L944.782 313.888Z",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M972.961 243.935V330.23",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.23 188.787V275.083L1039.83 291.393V205.098",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M944.617 227.309V313.604",
    stroke: "white",
    strokeWidth: 1.7126,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.05987c1b64c18de002744e518255d8d8.svg";
export { ForwardRef as ReactComponent };